export const GET_MINIMUM = `
query AppFetchRemoteConfigByKey($key: String!) {
  appFetchRemoteConfigByKey(key: $key) {
    success
    message
    code
    payload {
      key
      value
      data_type
    }
  }
}
`
